<script setup lang="ts">
import _ from "lodash";
import { onMounted, withDefaults, ref, provide } from "vue";
import Tippy, { ProvideTippy } from "@/base-components/Tippy";
import { PopperElement } from "tippy.js";

interface SideMenuTooltipProps {
  refKey?: string;
  as?: string | object;
  content: string;
  position: string;
}

// @ts-ignore
const toggleTooltip = (el: PopperElement) => {
  if (window.innerWidth <= 1260) {
    el._tippy?.enable();
  } else {
    el._tippy?.disable();
  }
};

// @ts-ignore
const initTooltipEvent = (tippyRef: PopperElement) => {
  window.addEventListener("resize", () => {
    if (props.position === "side") {
      toggleTooltip(tippyRef);
    }
  });
};

// @ts-ignore
const props = withDefaults(defineProps<SideMenuTooltipProps>(), {
  as: "a",
});

// @ts-ignore
const tippyRef = ref<PopperElement>();

// @ts-ignore
provide<ProvideTippy>("bind[sideMenuTooltipRef]", (el) => {
  tippyRef.value = el;
});

onMounted(() => {
  if (tippyRef.value) {
    if (props.position === "side") {
      toggleTooltip(tippyRef.value);
    }
    initTooltipEvent(tippyRef.value);
  }
});
</script>

<template>
  <Tippy
    :as="props.as"
    :content="props.content"
    :options="{
      placement: 'left',
    }"
    refKey="sideMenuTooltipRef"
  >
    <slot></slot>
  </Tippy>
</template>
